import { Store } from 'react-notifications-component';

const showNotification = (title, message, type) => {
  Store.addNotification({
    title,
    message,
    type,
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      duration: 4000,
      onScreen: true,
      pauseOnHover: true,
    },
  });
};

export default showNotification;
